var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.6572 12.999L11.1504 9.49218C11.9478 8.30829 12.3413 6.82909 12.1306 5.25292C11.7715 2.57196 9.57419 0.390224 6.89059 0.0504684C2.90065 -0.454405 -0.454428 2.90067 0.050474 6.89061C0.390318 9.57538 2.57235 11.7744 5.2536 12.1318C6.82977 12.3424 8.30926 11.9491 9.49286 11.1516L12.9997 14.6584C13.4573 15.116 14.1994 15.116 14.657 14.6584C15.1142 14.2002 15.1142 13.456 14.6572 12.999ZM2.31735 6.09374C2.31735 4.02597 3.99958 2.34374 6.06735 2.34374C8.13512 2.34374 9.81735 4.02597 9.81735 6.09374C9.81735 8.16151 8.13512 9.84374 6.06735 9.84374C3.99958 9.84374 2.31735 8.1621 2.31735 6.09374Z","fill":"#A8A8A8"}));
}

SearchIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
